import ApiClient from './ApiClient';

class EmailCampaignsAPI extends ApiClient {
  constructor() {
    super('email_campaigns', { accountScoped: true });
  }

  sendNow(id) {
    return axios.post(`${this.url}/${id}/send_now`);
  }

  pause(id) {
    return axios.post(`${this.url}/${id}/pause`);
  }

  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }

  stats(id) {
    return axios.get(`${this.url}/${id}/stats`);
  }

  recipients(id, page = 1) {
    return axios.get(`${this.url}/${id}/recipients`, { params: { page } });
  }

  preview(id, { contactId, subject, body } = {}) {
    return axios.post(`${this.url}/${id}/preview`, {
      contact_id: contactId,
      subject,
      body,
    });
  }

  testSend(id, contactId) {
    return axios.post(`${this.url}/${id}/test_send`, {
      contact_id: contactId,
    });
  }

  duplicate(id) {
    return axios.post(`${this.url}/${id}/duplicate`);
  }

  audiencePreview(audience) {
    return axios.post(`${this.url}/audience_preview`, { audience });
  }

  statsSummary() {
    return axios.get(`${this.url}/stats_summary`);
  }
}

export default new EmailCampaignsAPI();
